package co.maytes.standupbot.dashboard.features.standupruns

import co.maytes.standupbot.shared.dto.standuprun.DraftStateDto
import co.maytes.standupbot.shared.dto.standuprun.RunDraftDto

object DraftPanelRules {
    data class Groups(
        val responded: List<RunDraftDto>,
        val waiting: List<RunDraftDto>,
        val undelivered: List<RunDraftDto>,
    ) {
        val delivered: Int get() = responded.size + waiting.size
        val isEmpty: Boolean get() = responded.isEmpty() && waiting.isEmpty() && undelivered.isEmpty()
    }

    fun groups(drafts: List<RunDraftDto>): Groups =
        Groups(
            responded = drafts.filter { it.state.responded() }.sortedBy { it.displayName.lowercase() },
            waiting = drafts.filter { it.state == DraftStateDto.SENT }.sortedBy { it.displayName.lowercase() },
            undelivered = drafts.filter { it.state == DraftStateDto.FAILED }.sortedBy { it.displayName.lowercase() },
        )

    fun summary(
        groups: Groups,
        posted: Boolean,
    ): String? =
        when {
            groups.delivered == 0 -> null
            groups.responded.isEmpty() -> if (posted) "Nobody responded to their draft" else "Waiting on ${groups.delivered} ${noun(groups.delivered)}"
            else -> "${groups.responded.size} of ${groups.delivered} responded"
        }

    fun waitingHeading(posted: Boolean): String = if (posted) "Didn't respond" else "Waiting for a response"

    fun stateLabel(state: DraftStateDto): String =
        when (state) {
            DraftStateDto.SENT -> "Not yet"
            DraftStateDto.CONFIRMED -> "Looks good"
            DraftStateDto.EDITED -> "Edited"
            DraftStateDto.LEFT_OUT -> "Left out"
            DraftStateDto.FAILED -> "Couldn't deliver"
        }

    private fun DraftStateDto.responded(): Boolean = this == DraftStateDto.CONFIRMED || this == DraftStateDto.EDITED || this == DraftStateDto.LEFT_OUT

    private fun noun(count: Int): String = if (count == 1) "person" else "people"
}
